import { useState } from 'react';
import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';

import useMealPlanHint from '../../../../Hooks/useMealPlanHint';
import ThemeStyle from '../../../../Theme/styles';

import MealPlanTypes from '../../../MealPlanTypes';

import useModalPrompt from './hooks/useModalPrompt';
import ModalPrompt from './ModalPrompt';

const MealPlanTypeSelector = ({ modalId }) => {
  const { maybeShowMealPlanFeaturedHint } = useMealPlanHint();
  const { hideModalPrompt } = useModalPrompt();
  const [data, setData] = useState<{ value?: string }>();

  const _onTypeSelection = async (data: { value: string }) => {
    await hideModalPrompt(modalId, data);
    maybeShowMealPlanFeaturedHint();
  };

  return (
    <ModalPrompt
      id={modalId}
      baseWidth={400}
      title="Select Meal Plan Type"
      hasHeader={true}
      hasHeaderLine={true}
      closeOnDocumentClick={false}
      scrollEnabled={false}
      onBeforeShow={setData}
    >
      <View style={styles.contentContainer}>
        <View style={ThemeStyle.flexDirectionRowCenterCenter}>
          <MealPlanTypes value={data?.value} onChange={_onTypeSelection} />
        </View>
      </View>
    </ModalPrompt>
  );
};

const { styles } = StyleSheet.create({
  contentContainer: {
    ...ThemeStyle.spacingTopMedium,
    ...ThemeStyle.spacingBottomMedium,
  },
});
export default MealPlanTypeSelector;
